import React, {useState,useEffect} from 'react';
import {Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AddIcon from '@mui/icons-material/Add';
import AddBoxIcon from '@mui/icons-material/AddBox';
import DeleteIcon from '@mui/icons-material/Delete';
import {Inc,Item,Owner,Dataset,DataErrorset,DataErrorset2,EventTag,ItemNameLengthMin,ItemNameLengthMax,ItemPriceMin,ItemPriceMax,ItemPriceMaxHigh,ItemGuideLengthMax,ItemGuideNameLengthMax,ItemTagsMax,EventTagsMax,EventTagNameLengthMin,EventTagNameLengthMax,WordsLengthMax} from './Inc';
import Ajax from './Ajax';
import InputString from './InputString';
import InputNumber from './InputNumber';
import TwinInputString from './TwinInputString';
import RowData from './RowData';
import DropImage from './DropImage';
import ItemSpecSample from './ItemSpecSample';
import ItemLinkSample from './ItemLinkSample';
import HelpPop from './HelpPop';
import Loading from './Loading';
import Yesno from './Yesno';
import Problems from './Problems';
import EventTagSearch from './EventTagSearch';
import Toast from './Toast';
import {Theme} from './Theme';
//import useStyles from './Styles';
import {Tools} from './Tools';

interface ItemInputProps {
    owner:Owner,
	managerId:number,
	itemId:number,
	isOpen:boolean,
	close(updated:boolean,itemId:number):void,
}

interface ItemInputParams {
    links:DataErrorset[],
    specs:DataErrorset[],
    photo_ids:number[],
	guides:DataErrorset2[],
	event_tags:EventTag[],
	//tags:string[],
}

let itemImgs:{ [key: string]: string; } = {};

const ItemInput = (props:ItemInputProps)=> {
    Ajax.setEditorId(props.owner.owner_id);
	//const classes = useStyles();
	
    const defParam:ItemInputParams = {
        links:[],
        specs:[],
        photo_ids:[],
		guides:[],
		event_tags: [],
		//tags: [],
    }
	const defStates = {
        item: Inc.defaultItem(),
		pages: [] as Dataset[],
        yesno: '',
		deleteIndex: -1,
		problems: [] as string[],
        notFound: false,
		errors: [] as string[],
		hasItemError: false,
		sample: '',
		newEventTag: '',
		hasEventTagError: false,
		hasNewEventTagError: false,
        isLoading: true,
		params: defParam,
		paramErrors: [] as string[],
		hasParamError: false,
		isEventTagSearch: false,
    };
	const defTagStates = {
		tags: [] as string[],
		hasTagError: false,
	}
    const [states,setStates] = useState(defStates);
	const [tagStates,setTagStates] = useState(defTagStates);
	const [toast,setToast] = useState("");
	
    const load = (pages:Dataset[])=>{
        Ajax.send("item/get",{item_id:props.itemId,event_tag:'all'},(res:any)=>{
            //console.log("load",res);
            if( res.ok ){
				let hasItemError = false;
				let errors = [] as string[];
				if( !res.item.item_name || res.item.item_name==='' || res.item.item_name.length<ItemNameLengthMin ){
					hasItemError = true;
					errors = ['item_name'];
				}
				//console.log("loadItem",Inc.convItem(res.item));
				setTagStates({...defTagStates,tags:res.params.tags});
                setStates({...defStates,item:Inc.convItem(res.item),params:res.params,pages:pages,hasItemError:hasItemError,errors:errors,isLoading:false});
            } else {
                setStates({...states,notFound:true,isLoading:false});
            }
        });
    }

	const onChangeString = (name:keyof Item) => (value: string,hasError: boolean) => {
		//const item = {...states.item,[name]:value};
		validateItem({...states.item,[name]:value},name,hasError);
	};

	const onChangeNewEventTag = (value: string,hasError: boolean) => {
		//validateItem({...states.item,[name]:value},name,hasError);
		setStates({...states,newEventTag:value,hasNewEventTagError:hasError});
	};

	const onChangeGuide = (index:number,side:number) => (value: string,hasError: boolean) => {
		let guides = [...states.params.guides];
		if( side===0 ){
			guides[index].id = value;
			guides[index].id_error = hasError;
		} else if( side===1 ){
			guides[index].label = value;
			guides[index].label_error = hasError;
		}
		//setStates({...states,params:});

		hasError = false;
		for( let i=0; i<guides.length; i++ ){
			if( guides[i] ){
				if( guides[i].id_error || guides[i].label_error ){
					hasError = true;
				}
			}
		}

		//console.log(guides);

		const newParams = {...states.params,guides:guides};
		validateParam(newParams,'guides',hasError);
	};

	const onChangeNumber = (name:keyof Item) => (value: number,hasError: boolean) => {
		//const item = {...states.item,[name]:value};
		//console.log(item);
		//validateItem(item);
		//setStates({...states,item:item,hasError:hasError});
		validateItem({...states.item,[name]:value},name,hasError);
	};

	const onChangeSelect = (name:keyof Item) => (event: SelectChangeEvent) => {
		if (!event) {
			return;
		}
		let value = event.target.value;
		if( name==="rating_id" ){
			let tags = [...tagStates.tags];
			var index;
			if( value==="15" ){
				index = tags.indexOf("92");
				if( index>=0 ){
					tags.splice(index, 1);
				}
				tags = tags.concat("91");
			} else if( value==="18" ){
				index = tags.indexOf("91");
				if( index>=0 ){
					tags.splice(index, 1);
				}
				tags = tags.concat("92");
			} else {
				var index1 = tags.indexOf("91");
				if( index1>=0 ){
					tags.splice(index1, 1);
				}
				var index2 = tags.indexOf("92");
				if( index2>=0 ){
					tags.splice(index2, 1);
				}
			}
			setStates({ 
				...states,
				item:{...states.item,rating_id:parseInt(value)},
			});
			setTagStates({
				...tagStates,
				tags:tags,
			})
			//setStates2({ 
			//	...states2,
			//	params:{...states.params,tags:tags},
			//});
			//setParams({...params,tags:tags});
		} else {
			setStates({ 
				...states,
				item:{...states.item,[name]:value},
			});
		}
	}
	const onCheckTag = (id:string) => (event: React.ChangeEvent<HTMLInputElement>) => {
		let tags = [...tagStates.tags];
		let hasError = false;
		if( event.target.checked ){
			tags = tags.concat(id);
		} else {
			var index = tags.indexOf(id);
			tags.splice(index, 1);
		}

		let numTags = tags.length;
		if( tags.indexOf("91")>=0 || tags.indexOf("92")>=0 ){
			numTags--;
		}
		if( numTags>ItemTagsMax ){
			hasError = true;
		}
		setTagStates({...tagStates,tags:tags,hasTagError:hasError});
	}

	const onCheckEventTag = (index:number) => (event: React.MouseEvent<HTMLInputElement>) => {
		let tags = [...states.params.event_tags];
		tags[index].selected = !tags[index].selected;

		let numSelected = 0;
		for( let i=0; i<tags.length; i++ ){
			if( tags[i].selected ){
				numSelected++;
			}
		}
		setStates({...states,hasEventTagError:numSelected>EventTagsMax,params:{...states.params,event_tags:tags}});
	}

	const validateItem = (item:Item,name:string,hasError:boolean)=>{
		let errors = [...states.errors];
		const index = errors.indexOf(name);
		if( index>=0 ){
			if(!hasError){
				errors.splice(index, 1);
			}
		} else {
			if(hasError){
				errors.push(name);
			}
		}
		setStates({...states,item:item,errors:errors,hasItemError:errors.length>0});
	}

	const validateParam = (params:ItemInputParams,name:string,hasError:boolean)=>{
		let errors = [...states.paramErrors];
		const index = errors.indexOf(name);
		if( index>=0 ){
			if(!hasError){
				errors.splice(index, 1);
			}
		} else {
			if(hasError){
				errors.push(name);
			}
		}
		setStates({...states,params:params,paramErrors:errors,hasParamError:errors.length>0});
	}

    const checkItemName = async (value:string)=>{
        return await Ajax.sendAwait("item/name",{item_name:value,owner_id:props.owner.owner_id,item_id:states.item.item_id});
    }

    const changeParamTwin = (id:keyof ItemInputParams,index:number,value1:string,value2:string,hasError:boolean)=>{
		if( id!=="specs" && id!=='links' ){
			return;
		}
        let data = states.params[id];
        data[index] = {
            id: value1,
            label: value2,
			error: hasError,
        };
		hasError = false;
		for( let i=0; i<data.length; i++ ){
			if( data[i] ){
				if( data[i].error ){
					hasError = true;
				}
			}
		}
		const newParams = {...states.params,[id]:data};
		validateParam(newParams,id,hasError);
    }

    const changeImage = (id:string,src:string)=>{
        itemImgs[ id ] = src;
    }

	const addGuide = ()=>{
		const guides = [...states.params.guides];
		const guide = {
			id: '',
			label: '',
			id_error: false,
			label_error:false,
		} as DataErrorset2;
		guides.push(guide);
		setStates({...states,params:{...states.params,guides:guides}});
	}

	const confirmDelete = (event: React.MouseEvent)=>{
		const index = parseInt(event.currentTarget.getAttribute('data-num') as string);
		setStates({...states,yesno:'この段落を削除します。\nよろしいですか？',deleteIndex:index});
	}

	const deleteGuide = ()=>{
		if( states.deleteIndex<0 ){
			return;
		}
		let guides = [...states.params.guides];
		guides.splice(states.deleteIndex,1);
		setStates({...states,deleteIndex:-1,yesno:'',params:{...states.params,guides:guides}});
	}

	const openEventTagSearch = ()=>{
		setStates({...states,isEventTagSearch:true});
	}
	const closeEventTagSearch = ()=>{
		setStates({...states,isEventTagSearch:false});
	}

	const close = ()=>{
		setStates(defStates);
		setTagStates(defTagStates);
		props.close(false,0);
	}

    const confirm = ()=>{
        //console.log("states",states);
        //console.log("itemImgs",itemImgs);
        //console.log("errors",errors);
		if( !states.hasItemError && !states.hasParamError && !tagStates.hasTagError && !states.hasEventTagError ){
        	setStates({...states,yesno:"この内容で登録します。\nよろしいですか？",deleteIndex:-1});
			return;
		}
		const errors = [] as string[];
		if( states.hasItemError ){
			for( let i=0; i<states.errors.length; i++ ){
				let mes = '';
				if(states.errors[i]==='item_name'){
					mes = '商品名';
				} else if(states.errors[i]==='img_id'){
					mes = 'メイン画像';
				} else if(states.errors[i]==='item_guide'){
					mes = '商品の紹介文';
				} else if(states.errors[i]==='unit'){
					mes = '単位';
				} else if(states.errors[i]==='price'){
					mes = '価格';
				} else if(states.errors[i]==='upto'){
					mes = '販売数の制限';
				} else if(states.errors[i]==='page_id'){
					mes = 'シリーズ';
				} else if(states.errors[i]==='soldout_id'){
					mes = '完売後の扱い';
				} else if(states.errors[i]==='cancel_id'){
					mes = '完売後にキャンセルされた時の扱い';
				} else if(states.errors[i]==='rating_id'){
					mes = 'レイティング';
				} else if(states.errors[i]==='words'){
					mes = '検索キーワード';
				}
				if( mes!=='' ){
					errors.push(mes);
				}
			}
		}
		if( states.hasEventTagError ){
			errors.push('イベントタグ');
		}
		if( tagStates.hasTagError ){
			errors.push('文芸タグ');
		}
		if( states.hasParamError ){
			for( let i=0; i<states.paramErrors.length; i++ ){
				let mes = '';
				if(states.paramErrors[i]==='specs'){
					mes = '詳細情報';
				} else if(states.paramErrors[i]==='links'){
					mes = '関連リンク';
				} else if(states.paramErrors[i]==='photo_ids'){
					mes = '追加画像';
				} else if(states.paramErrors[i]==='guides'){
					mes = '商品の紹介文';
				}
				if( mes!=='' ){
					errors.push(mes);
				}
			}
		}
		if( errors.length===0 ){
			let tmp1 = '';
			if( states.errors.length>0 ){
				tmp1 = states.errors.join("/");
			}
			let tmp2 = '';
			if( states.paramErrors.length>0 ){
				tmp2 = states.paramErrors.join("/");
			}
			errors.push('原因不明（システム側に異常の可能性あり）\n'+tmp1+':'+tmp2+'');
		}

		setStates({...states,problems:errors});
		return;

    }
    const yes = ()=>{
		if( states.deleteIndex>=0 ){
			deleteGuide();
			return;
		}
        let item_id = 0;
        if( states.item.item_id && states.item.item_id>0 ){
            item_id = states.item.item_id;
        }
		//console.log("item/yes:managerId",props.managerId);
        setStates({...states,yesno:"",isLoading:true});
        Ajax.send("item/do",{item_id:item_id,manager_id:props.managerId,item:states.item,params:{...states.params,tags:tagStates.tags},new_imgs:itemImgs},(res:any)=>{
            if( res.ok ){
                //setStates({...defStates,isLoading:false});
				setStates(defStates);
				setTagStates(defTagStates);
				props.close(true,res.item_id);
            } else {
                setStates({...states,yesno:"",isLoading:false});
				setToast("登録できませんでした");
            }
        },(err:any)=>{
            setStates({...states,yesno:"",isLoading:false});
			setToast("登録できませんでした");
        });
    }
    const no = ()=>{
        setStates({...states,deleteIndex:-1,yesno:"",problems:[]});
    }
    const closeToast = ()=>{
        setToast("");
    }
	const SelectField = (props:{name:keyof Item,value:string,list:Dataset[],width?:number,empty?:boolean})=>{
		if( props.list.length===0 ){
			return (null);
		}
		let w = 2000;
		if( props.width ){
			w = props.width;
		}

		//console.log("value("+props.value+")");

		let value = props.list[0].id;
		if( props.empty ){
			value = '';		
		}
		if( props.value && props.value!=='undefined' ){
			let exist = false;
			for( let i=0; i<props.list.length; i++ ){
				if( props.list[i].id===props.value ){
					exist = true;
				}
			}
			if( exist ){
				value = props.value;				
			}
		}


		return (
			<Select
				id={"select"+props.name}
				value={value}
				onChange={onChangeSelect(props.name)}
				variant="standard"
				style={{width:'100%',maxWidth:`${w}px`,backgroundColor:'#EEEEEE',boxSizing:'border-box',padding:'0.75em 0.5em'}}
			>
				{props.empty && 
				<MenuItem value='' key='empty'>　</MenuItem>
				}
				{props.list.map((data:Dataset,index:number)=>{
					const key = props.name+index;
					return <MenuItem value={data.id} key={key}>{data.label}</MenuItem>
				})}
			</Select>
		);
	}
	const openSpecSample = ()=>{
		setStates({...states,sample:'spec'});
		//setSample('spec');
	}
	const openLinkSample = ()=>{
		setStates({...states,sample:'link'});
		//setSample('link');
	}
	const closeSample = ()=>{
		setStates({...states,sample:''});
		//setSample('');
	}

	const gridTags = ()=>{
		return (
		<Grid container spacing={2}>
		{Inc.literatureTags.map((data:Dataset,index:number)=>{
			const key = "tag"+index;
			const disabled = (data.id==='91' || data.id==='92') ? true : false;
			//const checked = states.params.tags.indexOf(data.id)>=0;
			const checked = tagStates.tags.indexOf(data.id)>=0;
			return <Grid item key={key} xs={6} sm={6} md={3}><FormControlLabel control={<Checkbox color={tagStates.hasTagError ? "secondary" : "primary"} checked={checked} disabled={disabled} onChange={onCheckTag(data.id)}/>} label={data.label}/></Grid>
		})}
		{tagStates.hasTagError ? (
		<div className="formError">文芸タグは{ItemTagsMax}個以下にして下さい（R15+/R18+は別腹）</div>
		):(
		<div className="formHelper">{ItemTagsMax}個まで選択可（R15+/R18+は別腹）</div>
		)}
		</Grid>
		);
	};

	const addEventTag = ()=>{
		const value = states.newEventTag.trim();
		if( value!==states.newEventTag ){
			setStates({...states,newEventTag:value});
			return;			
		}
		if(value===''){
			setToast('新しいイベントタグを入力して下さい')
			return;
		}
		if(states.hasNewEventTagError){
			setToast("このイベントタグは追加できません");
			return;
		}
		const event_tags = [...states.params.event_tags];
		for( let i=0; i<event_tags.length; i++ ){
			if( event_tags[i].name===value ){
				setToast("このイベントタグはすでに追加されています");
				return;
			}
		}

		let numSelected = 0;
		for( let i=0; i<states.params.event_tags.length; i++ ){
			if( states.params.event_tags[i].selected ){
				numSelected++;
			}
		}
		
		const tag = {
			id: '0',
			short: '',
			name: value,
			new: true,
			selected: numSelected<EventTagsMax,
		} as EventTag;
		event_tags.push(tag);
		setStates({...states,newEventTag:'',params:{...states.params,event_tags:event_tags}});
	}

	const removeEventTag = (event: React.MouseEvent)=>{
		const index = parseInt(event.currentTarget.getAttribute('data-index') as string);
		const event_tags = [...states.params.event_tags];
		event_tags.splice(index,1);

		let numSelected = 0;
		for( let i=0; i<event_tags.length; i++ ){
			if( event_tags[i].selected ){
				numSelected++;
			}
		}

		setStates({...states,hasEventTagError:numSelected>EventTagsMax,params:{...states.params,event_tags:event_tags}});
	}

	const addSearchEventTag = (tags:EventTag[])=>{
		const event_tags = [...states.params.event_tags];
		for( let i=0; i<tags.length; i++ ){
			event_tags.push(tags[i]);
		}

		let numSelected = 0;
		for( let i=0; i<event_tags.length; i++ ){
			if( event_tags[i].selected ){
				numSelected++;
			}
		}

		setStates({...states,isEventTagSearch:false,hasEventTagError:numSelected>EventTagsMax,params:{...states.params,event_tags:event_tags}});
	}

    useEffect( ()=>{
		if(!props.isOpen){
			return;
		}
		//console.log("effect");
        itemImgs = {};
        Ajax.send("item/pages",{format:"ID:{id}　{name}"},(res:any)=>{
			//console.log("getpages");
			let pages;
            if( res.ok ){
                pages = res.pages;
            } else {
                pages = [];
            }
            load(pages);
        });
    },[props.isOpen]);

    if( states.notFound ){
        return (
            <Redirect to="/"/>
        );
    }

    let links:Dataset[] = [];
    for( let i=0 ; i<5 ; i++ ){
        if( states.params.links[i] ){
            links.push( states.params.links[i] );
        } else {
            links.push({
                id:"",
                label:"",
            });
        }
    }

    let specs:Dataset[] = [];
    for( let i=0 ; i<8 ; i++ ){
        if( states.params.specs[i] ){
            specs.push( states.params.specs[i] );
        } else {
            specs.push({
                id:"",
                label:"",
            });
        }
    }

    let photo_ids:number[] = [];
    for( let i=0 ; i<8 ; i++ ){
        if( states.params.photo_ids[i] ){
            photo_ids.push( states.params.photo_ids[i] );
        } else {
            photo_ids.push(0);
        }
    }

    let helperPrice = ItemPriceMin + "円以上";
    let maxPrice = ItemPriceMax;
    if( props.owner.high_flag==="1" ){
        maxPrice = ItemPriceMaxHigh;
    }
	helperPrice = ItemPriceMin+"円以上"+Tools.comma(maxPrice)+"円以下";

    const uptoEnd = states.item.unit + "まで";

	if( !props.isOpen ){
		return null;
	}

    if( states.isLoading ){
        return (
            <Loading isLoading={true}/>
        );
    }

    //if( states.redirectId>0 ){
    //    const to = "/item/"+String(states.redirectId);
    //    return (
    //        <Redirect to={to}/>
    //    )
    //}

    let item_id = "未定";
    if(states.item.item_id>0){
        item_id = String(states.item.item_id);
    }

    //let toCancel = "/item";
    //if( states.item.item_id>0 ){
    //    toCancel = "/item/"+String(states.item.item_id);
    //}

    //let error = false;
    //if( !states.item.item_name || states.item.item_name==="" || states.item.price<100 || states.item.price>maxPrice ){
    //    error = true;
    //}

	let tax_inc = "1";
	if( states.item.tax_inc ){
		tax_inc = states.item.tax_inc;
	}

	//console.log("refresh");
	window.scrollTo(0, 0);

	return (
		<Dialog
			fullScreen
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
		>
			<DialogContent style={{padding:"0",margin:"0",backgroundColor:'#F5F5F5'}}>

				<AppBar position="fixed" style={{backgroundColor:`#FFFFFF`}}>
					<Toolbar variant="dense" style={{backgroundColor:`#FFFFFF`}}>
						<div style={{color:'#333333',flex:'1'}}><ShoppingCartIcon style={{verticalAlign:'middle',marginRight:'0.25em'}}/><span style={{verticalAlign:'middle'}}>商品編集</span><span style={{verticalAlign:'middle',fontSize:'80%'}}>（本・雑貨）</span></div>
						<Button variant="text" color="primary" onClick={close} style={{marginRight:`0.5em`}}>もどる</Button>
						{(!states.hasItemError && !states.hasParamError && !tagStates.hasTagError) ? (
						<Button variant="contained" color="primary" onClick={confirm}>登録</Button>
						):(
						<Button variant="contained" color="info" onClick={confirm}>登録</Button>
						)}
					</Toolbar>
				</AppBar>

				<div style={{maxWidth:'1280px',width:'100%',boxSizing:'border-box',padding:"4em 1em",margin:'0 auto',backgroundColor:'#FFFFFF'}}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">メイン画像</Typography>
							<div className="formExplanation">
								販売ページの最初に表示される大きな画像です。<br/>
								<b>幅1280pxの画像</b>を用意するとキレイに表示されます。<br/>
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<div style={{textAlign:"center"}}>
								<DropImage noHelper={true} owner_id={props.owner.owner_id} img_id={states.item.img_id} id="img" change={changeImage}/>
							</div>
							<div className="formHelper">
							1280pxより大きい場合は自動的に縮小されます（PNG / JPEG / GIF）<br/>
							</div>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">追加画像</Typography>
							<div className="formExplanation">
								商品ページのフォトギャラリーに表示される画像です。<br/>
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<Grid container spacing={2}>
								{photo_ids.map((img_id:number,index:number)=>{
									const key = "photo"+String(index+1);
									const name = "追加画像" + String(index+1);
									return (
										<Grid key={key} item xs={6} sm={4}>
											<DropImage noHelper={true} owner_id={props.owner.owner_id} img_id={img_id} data={itemImgs[key]} name={name} id={key} change={changeImage}/>
										</Grid>
									);
								})}
							</Grid>
							<div className="formHelper" style={{marginTop:'1em'}}>
								1280pxより大きい場合は自動的に縮小されます（PNG / JPEG / GIF）<br/>
							</div>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>						
						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">商品名
							<span className="formRequired">必須</span>
							</Typography>
							<div className="formExplanation">
								すでに誰かが使用されている商品名は使えません<br/>
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<InputString label="商品名" required={true} value={states.item.item_name} onChange={onChangeString("item_name")} duplicate={checkItemName} helper={ItemNameLengthMin+'文字以上'+ItemNameLengthMax+'文字以内'} opt={{minLength:ItemNameLengthMin,maxLength:ItemNameLengthMax}}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>						
						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">商品の紹介文</Typography>
							<div className="formExplanation">
								商品の内容やチャームポイントをなるべくわかりやすく書いてください<br/>
								段落ごとに見出しをつけることもできます（段落は最大５個）<br/>
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							{states.params.guides.map((guide:DataErrorset2,index:number)=>{
								const key = "guide"+index;
								return (
							<div style={{marginBottom:'1em',position:'relative'}} key={key}>
								<div style={{marginBottom:'0.5em'}}><InputString label="見出し" required={false} value={guide.id} onChange={onChangeGuide(index,0)} helper={ItemGuideNameLengthMax+'文字以内・省略可'} opt={{maxLength:ItemGuideNameLengthMax}}/></div>
								<div><InputString label="本文" required={false} value={guide.label} onChange={onChangeGuide(index,1)} helper={Tools.comma(ItemGuideLengthMax)+'文字以内'} opt={{rows:10,maxLength:ItemGuideLengthMax}}/></div>
								{index>0 &&
								<div style={{textAlign:'right',position:'absolute',bottom:'-0.5em',right:'0',margin:'0',padding:'0'}}>
									<Button variant="text" color="secondary" size="small" onClick={confirmDelete} data-num={index}><DeleteIcon/> 段落削除</Button>
								</div>
								}
							</div>
								)
							})}
							<div style={{textAlign:'left'}}>
								<Button variant="outlined" color="primary" onClick={addGuide} disabled={states.params.guides.length===5}><AddIcon/> 段落追加</Button>
							</div>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">単位
							<span className="formRequired">必須</span>
							</Typography>
							<div className="formExplanation">
								商品の単位（数え方）に適切な言葉を選んでください
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<SelectField value={states.item.unit} name="unit" list={Inc.units} width={160}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>						
						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">価格
							<span className="formRequired">必須</span>
							</Typography>
							<div className="formExplanation">
								「税抜」で登録しておくと、今後消費税率が変わった時に自動的に新しい消費税率で計算した価格が表示されます
							</div>
						</Grid>
						<Grid item xs={4} sm={2} md={2}>
							<SelectField name="tax_inc" value={tax_inc} list={Inc.taxs}/>
						</Grid>
						<Grid item xs={8} sm={7} md={6}>
							<InputNumber label="価格" required={true} value={states.item.price} onChange={onChangeNumber("price")} helper={helperPrice} opt={{minValue:ItemPriceMin,maxValue:maxPrice,endAdornment:"円"}}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>						
						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">販売数の制限</Typography>
							<div className="formExplanation">
								いわゆる「お一人様○○個まで」の設定ができます
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<InputNumber label="販売数の制限" required={true} value={states.item.upto} onChange={onChangeNumber("upto")} helper="制限しない場合は0" opt={{startAdornment:"お一人様",endAdornment:uptoEnd}}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>						
						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">シリーズ</Typography>
							<div className="formExplanation">
								同じシリーズの商品は各商品ページにズラリと表示され、関連商品としてお客様に選んでいただきやすくなります
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							{states.pages.length>0 ? (
							<SelectField name="page_id" value={String(states.item.page_id)} list={states.pages} empty={true}/>
							):(
							<div style={{color:'pink',fontSize:'80%'}}>
								※シリーズを設定したい場合は、「商品と納品」→「シリーズ登録」で作成してください<br/>
							</div>
							)}
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>						
						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">完売後の扱い
							<span className="formRequired">必須</span>
							</Typography>
							<div className="formExplanation">
								完売時に表示されるメッセージです
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<SelectField name="soldout_id" value={String(states.item.soldout_id)} list={Inc.soldouts} width={280}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>						
						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">完売後にキャンセルされた時の扱い
							<span className="formRequired">必須</span>
							</Typography>
							<div className="formExplanation">
								ご注文のキャンセルなどで在庫が復活した場合の対応を選択できます
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<SelectField name="cancel_id" value={String(states.item.cancel_id)} list={Inc.cancels} width={280}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>						
						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">レイティング
							<span className="formRequired">必須</span>
							</Typography>
							<div className="formExplanation">
								年齢による閲覧制限が必要な場合は選択してください
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<SelectField name="rating_id" value={String(states.item.rating_id)} list={Inc.ratings} width={180}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>

						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">文芸タグ</Typography>
							<div className="formExplanation">
								文芸作品の場合は、タグを設定しておくと作品を探してもらいやすくなります<br/>
								（文芸作品以外では不要です）<br/>
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							{gridTags()}
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>

						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">イベントタグ</Typography>
							<div className="formExplanation">
								イベントで取り扱った作品（予定も含む）は該当イベントをチェックして下さい。<br/>
								<br/>
								イベントは新しく追加することもできます。<HelpPop text={(
									<div>
										<p style={{margin:'0',padding:'0',marginBottom:'1em'}}>追加したばかりのイベントは「仮登録」となり、あなただけしか使えません。</p>
										<p style={{margin:'0',padding:'0',marginBottom:'1em'}}>開催期間などを架空ストアが確認した後でほかの作家さんも使えるようになります。</p>
										<div style={{backgroundColor:'#F5F5F5',padding:'1em',fontSize:'90%'}}>
										※半年以上先のイベントは登録できません。<br/>
										※2021年以前および1年以上前のイベントは登録できません。<br/>
										※登録が重複した場合など不要になったイベントは架空ストアで定期的に確認して適宜削除いたします。
										</div>
									</div>
								)}/>
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<List dense={true} style={{margin:'0',padding:'0',marginBottom:'1em'}}>
							{states.params.event_tags.map((tag:EventTag,index:number)=>{
								const key = 'tag'+index;
								let label = '';
								let labelColor = Theme.palette.primary.main;
								if( tag.admit ){
									if( tag.start ){
										label = tag.start;
										if( tag.end && tag.end!==tag.start ){
											label = label + "～" + tag.end;
										}
									} else {
										label = '開催期間未定';
									}
								} else if( tag.new ){
									label = 'NEW!';
									labelColor = Theme.palette.success.main;
								} else {
									label = '仮登録';
									labelColor = Theme.palette.info.main;
								}

								return (
									<ListItem key={key} style={{margin:'0',padding:'0'}} dense={true} button={true} onClick={onCheckEventTag(index)}>
										<ListItemIcon style={{marginRight:'0'}}>
											<Checkbox
												checked={tag.selected}
												tabIndex={-1}
												disableRipple
												inputProps={{ 'aria-labelledby': key }}
												color={states.hasEventTagError ? "secondary" : "primary"}
											/>
										</ListItemIcon>
										<ListItemText style={{marginLeft:'0',paddingLeft:'0'}} primary={tag.name} secondary={
											<span style={{fontSize:'90%',color:labelColor}}>{label}</span>
										}/>
										<ListItemSecondaryAction><IconButton onClick={removeEventTag} data-index={index}><DeleteIcon/></IconButton></ListItemSecondaryAction>
									</ListItem>
								)
							})}
								<ListItem style={{margin:'0',padding:'0',marginTop:'1em'}} dense={true}>
								{states.params.event_tags.length===0 &&
								<div className="formHelper">「検索」でイベントを探しましょう</div>
								}
								{states.params.event_tags.length>0 && states.hasEventTagError &&
								<div className="formError">イベントタグは{EventTagsMax}個以下にして下さい</div>
								}
								{states.params.event_tags.length>0 && !states.hasEventTagError &&
								<div className="formHelper">{EventTagsMax}個まで選択可</div>
								}
									<ListItemSecondaryAction><Button variant="outlined" color="primary" onClick={openEventTagSearch}>検索</Button></ListItemSecondaryAction>
								</ListItem>
							</List>
							<InputString label="新しいイベント" required={false} value={states.newEventTag} onChange={onChangeNewEventTag} helper={EventTagNameLengthMin+'文字以上'+EventTagNameLengthMax+'文字以内'} opt={{minLength:ItemNameLengthMin,maxLength:ItemNameLengthMax,endAdornment:<IconButton color="primary" onClick={addEventTag}><AddBoxIcon/></IconButton>}}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>


						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">検索キーワード</Typography>
							<div className="formExplanation">
								商品名・商品の紹介文・作家名のほか、ここに設定した語句も商品検索時の対象となります（実際の内容からかけ離れた語句を設定しないようご注意ください）
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<InputString label="検索キーワード" required={false} value={states.item.words} onChange={onChangeString("words")} helper={Tools.comma(WordsLengthMax)+'文字以内（カンマまたは改行区切り）'} opt={{rows:4,maxLength:WordsLengthMax,placeholder:'キーワード1,キーワード2,キーワード3…'}}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>


						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">詳細情報</Typography>
							<div className="formExplanation">
								素材、サイズ、製法、色などの詳細情報を登録できます<br/>
								<Button variant="outlined" color="primary" style={{marginTop:'0.5em'}} size="small" onClick={openSpecSample}>入力例を表示</Button>
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
						{specs.map((data:Dataset,index:number)=>{
							const key = "spec"+index;
							const name1 = "詳細"+(index+1);
							const name2 = "詳細"+(index+1)+"の内容";
							return (
								<TwinInputString key={key} value1={data.id} value2={data.label} name1={name1} name2={name2} maxLength1={10} maxLength2={100} placeholder1="サイズ、重さ、色など" placeholder2="A6、300g、赤など" error={true} change={changeParamTwin} id="specs" index={index} row/>
							)
						})}
							{states.paramErrors.indexOf('specs')>=0 &&
							<div className="formError" style={{marginTop:'0.5em'}}>文字数オーバーまたは入力が不完全な項目があります</div>
							}
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>						
						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">関連リンク</Typography>
							<div className="formExplanation">
								個人サイトやSNSなどへのリンクを表示できます<br/>
								<Button variant="outlined" color="primary" style={{marginTop:'0.5em'}} size="small" onClick={openLinkSample}>入力例を表示</Button>
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
						{links.map((data:Dataset,index:number)=>{
							const key = "link"+index;
							const name1 = "リンク先"+(index+1);
							const name2 = "URL";
							return (
								<TwinInputString key={key} value1={data.id} value2={data.label} name1={name1} name2={name2} maxLength1={100} maxLength2={300} placeholder1="サイトやSNSのタイトル" placeholder2="http://～" regex2="^https?:\/\/" change={changeParamTwin} id="links" index={index}/>
							)
						})}
							{states.paramErrors.indexOf('links')>=0 &&
							<div className="formError" style={{marginTop:'0.5em'}}>文字数オーバーまたは入力が不完全な項目があります</div>
							}
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">チャリティ
							<span className="formRequired">必須</span>
							</Typography>
							<div className="formExplanation">
								災害復興支援など義援金への寄付を目的とした商品の場合は「はい」を選ぶと架空ストアの販売手数料が０％になります<br/>
								<b>※寄付の手続きは作家さん側でそれぞれ行って下さい。</b><br/>
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<SelectField name="charity_flag" value={String(states.item.charity_flag)} list={Inc.charitys} width={280}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>

                    </Grid>
					<div style={{maxWidth:'300px',marginLeft:'auto',marginTop:'2em',backgroundColor:'#F0F0F0',padding:'1em',boxSizing:'border-box'}}>
                        <RowData name="商品ID" value={item_id} height={true}/>
                        <RowData name="在庫" value={String(states.item.num_stock)+states.item.unit} height={true}/>
                        <RowData name="前回販売" value={states.item.new_date} height={true}/>
						<div style={{position:"relative"}}>
							<div style={{position:"absolute",top:"0",left:"0",width:"40%"}}>状態</div>
							<div style={{marginLeft:"40%",textAlign:"right"}}>
								{Tools.colorLabel("item_status",states.item.status,states.item.status_label)}
							</div>
						</div>
					</div>
				</div>
			</DialogContent>
			<ItemSpecSample isOpen={states.sample==='spec'} close={closeSample}/>
			<ItemLinkSample isOpen={states.sample==='link'} close={closeSample}/>
            <Yesno mes={states.yesno} yes={yes} no={no} isOpen={states.yesno!==""}/>
			<Problems names={states.problems} yes={yes} no={no} force={true} isOpen={states.problems.length>0}/>
			<EventTagSearch close={closeEventTagSearch} add={addSearchEventTag} isOpen={states.isEventTagSearch} ownerId={props.owner.owner_id} currentTags={states.params.event_tags}/>
            <Toast mes={toast} close={closeToast}/>
		</Dialog>
	);
}

export default ItemInput;
